import { ACTION_CONSTANTS } from 'actions/constants';
import { MODAL_TYPES } from 'actions/modals';

const INITIAL_STATE = { all: [] };

export function modals(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ACTION_CONSTANTS.modals.open:
      // dont allow more than one error at at time
      if (
        !action.payload.props.modalType === MODAL_TYPES.error ||
        !stateHasError(state)
      ) {
        return { all: state.all.concat([action.payload]) };
      } else {
        return state;
      }
    case ACTION_CONSTANTS.modals.close:
      return removeModal(state, action.payload.key);
    default:
      return state;
  }
}

function removeModal(state, key) {
  let filtered = [];
  filtered = state.all.filter(modal => {
    return modal.props.key !== key;
  });
  return { all: filtered };
}

function stateHasError(state) {
  return state.all.some(modal => {
    return modal.props.modalType === MODAL_TYPES.error;
  });
}



// WEBPACK FOOTER //
// ./src/reducers/modals.js